import { render, staticRenderFns } from "./AllInvestorsList.vue?vue&type=template&id=36e5e4bc"
import script from "./AllInvestorsList.vue?vue&type=script&lang=js"
export * from "./AllInvestorsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports